import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import useUserBranches from '../../core/queries/useUserBranches';
import type { Language } from '../../core/types';
import type { UserBranch } from '../../user/types';

const getBranchName = (language: Language, item?: UserBranch) => {
    if (!item) {
        return '';
    }

    return item[`name${language.toUpperCase()}` as keyof UserBranch] as string;
};

const useStockLocations = (
    location?: string
): {
    shouldShowBranchCode: boolean;
    branches: {
        id: string;
        name: string;
        isMainStock?: boolean;
    }[];
} => {
    const { language } = useStoreAndLanguageParams();
    const { branches, locationCode } = useUserBranches();
    const sortedBranches = branches.slice().sort((a, b) => {
        if (a.isMainStock && !b.isMainStock) {
            return -1;
        }

        return 0;
    });

    if (location) {
        return {
            shouldShowBranchCode: sortedBranches.length > 1,
            branches: [
                {
                    id: location,
                    name: getBranchName(
                        language,
                        sortedBranches.find(item => item.id === location)
                    ),
                },
            ],
        };
    }

    if (branches.length === 0 && locationCode) {
        return {
            shouldShowBranchCode: false,
            branches: [{ id: locationCode, name: '', isMainStock: true }],
        };
    }

    return {
        shouldShowBranchCode: branches.length > 1,
        branches: sortedBranches.map(item => ({
            id: item.id,
            name: getBranchName(language, item),
            isMainStock: item.isMainStock,
        })),
    };
};

export default useStockLocations;
